import { Component, OnInit } from '@angular/core';

import { AOService } from '../../services/ao.service';

@Component({
  selector: 'ao-app',
  templateUrl: './ao-app.component.html',
  styleUrls: ['./ao-app.component.scss'],
})
export class AOAppComponent implements OnInit {

  constructor(
    public ao: AOService,
  ) {
  }

  ngOnInit() {
  }

}
